import { render } from "./extraButtons.vue?vue&type=template&id=2d53b789&scoped=true"
import script from "./extraButtons.vue?vue&type=script&lang=js"
export * from "./extraButtons.vue?vue&type=script&lang=js"

import "./extraButtons.vue?vue&type=style&index=0&id=2d53b789&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d53b789"

export default script